import { SharedTableHeader } from "../../../accounting/editableTable/SharedTableHeader";
import {
    TransactionProxyObject,
    NUMBER_OF_CELLS_PER_LINE,
} from "../AddTransactionsModal";

export const EditableTableHeader = () => (
    <SharedTableHeader<TransactionProxyObject>
        numberOfCellsPerLine={NUMBER_OF_CELLS_PER_LINE}
        columns={["Date", "Category", "Amount", "Description"]}
        editableGridCols="40fr 150fr 250fr 122fr 434fr 60fr"
    />
);
